import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, ChevronDown, ChevronUp } from 'lucide-react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('okni_cookie_consent');
    if (!consent) {
      // Small delay to avoid flash on page load
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('okni_cookie_consent', JSON.stringify({
      essential: true,
      analytics: true,
      date: new Date().toISOString()
    }));
    setVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('okni_cookie_consent', JSON.stringify({
      essential: true,
      analytics: false,
      date: new Date().toISOString()
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col gap-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Cookie className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-700 dark:text-gray-300">
                Oknî utilise des cookies essentiels pour le fonctionnement de la plateforme (authentification, préférences). 
                Aucun cookie publicitaire n&apos;est utilisé.
                {' '}
                <button 
                  onClick={() => setShowDetails(!showDetails)} 
                  className="inline-flex items-center gap-1 text-primary hover:underline font-medium"
                >
                  {showDetails ? 'Masquer les details' : 'En savoir plus'}
                  {showDetails ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                </button>
              </p>
            </div>
          </div>

          {showDetails && (
            <div className="ml-13 p-4 bg-gray-50 dark:bg-gray-800 rounded-xl text-sm text-gray-600 dark:text-gray-400 space-y-3">
              <div>
                <p className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Cookies essentiels</p>
                <p>Token JWT (authentification), préférences (mode sombre, langue), consentement cookies. Ces cookies sont nécessaires au fonctionnement de la plateforme.</p>
              </div>
              <div>
                <p className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Cookies analytiques (optionnels)</p>
                <p>Statistiques d&apos;utilisation agregees pour ameliorer le service. Aucune donnee personnelle n&apos;est partagee avec des tiers.</p>
              </div>
              <p className="pt-2 border-t border-gray-200 dark:border-gray-700">
                <Link to="/privacy" className="text-primary hover:underline">
                  Consulter notre Politique de Confidentialité
                </Link>
              </p>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
            <button 
              onClick={acceptEssential} 
              className="px-4 py-2.5 text-sm font-medium border border-gray-300 dark:border-gray-600 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            >
              Essentiels uniquement
            </button>
            <button 
              onClick={acceptAll} 
              className="px-4 py-2.5 text-sm font-medium bg-primary text-white rounded-xl hover:bg-primary/90 transition-colors"
            >
              Tout accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
